const EMAIL_KEY = 'capexia.auth.email'
const MFA_TOKEN_KEY = 'capexia.auth.pending_mfa_token'

export function setAuthEmail(email: string | null) {
  if (email) sessionStorage.setItem(EMAIL_KEY, email)
  else sessionStorage.removeItem(EMAIL_KEY)
}

export function getAuthEmail(): string | null {
  return sessionStorage.getItem(EMAIL_KEY)
}

export function setPendingMfaToken(token: string | null) {
  if (token) sessionStorage.setItem(MFA_TOKEN_KEY, token)
  else sessionStorage.removeItem(MFA_TOKEN_KEY)
}

export function getPendingMfaToken(): string | null {
  return sessionStorage.getItem(MFA_TOKEN_KEY)
}

